import {
  createBaseAsyncHandlers,
  createFailAction,
  createStartAction,
  createSuccessAction,
  initialState,
} from '../../redux-util/async-helpers';
import { createReducer } from '../../redux-util/general-helpers';

export const assetReducerInitialState = {
  ...initialState,
  pastQueries: [],
};

export function makeAssetReducer(key) {
  const baseHandlers = createBaseAsyncHandlers(key);

  function doFetchStart(state, action) {
    const isFirstPage = action.data[0].offset === 0;
    const stateToUse = isFirstPage ? assetReducerInitialState : state;
    const baseResult = baseHandlers[action.type](stateToUse, action);
    // Search needs to show past queries
    if (isFirstPage) {
      const updatedQueries = state.pastQueries.slice();
      if (state.data && state.successQuery) {
        updatedQueries.unshift({
          args: state.successQuery,
          count: state.data.totalElements,
        });
      }
      baseResult.pastQueries = updatedQueries.slice(0, 20);
    }
    return baseResult;
  }

  function doFetchSuccess(state, action) {
    const baseResult = baseHandlers[action.type](state, action);
    const oldBooks = state.data ? state.data.content || [] : [];
    const vbids = baseResult.data.content.map(d => d.vbid);
    return {
      ...baseResult,
      data: {
        ...baseResult.data,
        content: oldBooks.concat(vbids),
      },
    };
  }

  function doFetchFail(state, action) {
    return baseHandlers[action.type](state, action);
  }

  const fetchStart = createStartAction(key).type;
  const fetchSuccess = createSuccessAction(key).type;
  const fetchFail = createFailAction(key).type;

  const extras = {
    [fetchStart]: doFetchStart,
    [fetchSuccess]: doFetchSuccess,
    [fetchFail]: doFetchFail,
  };

  return createReducer(assetReducerInitialState, extras);
}
